import { NodeToolbar, Position } from "@xyflow/react";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export function NodeToolbarTop({ children }: Props) {
  return (
    <NodeToolbar position={Position.Top} offset={60} className="nopan">
      {children}
    </NodeToolbar>
  );
}
